import { queryOptions } from "@tanstack/react-query";
import { getUserSession } from "~/lib/api/auth.api";

export const authQueries = {
  all: ["auth"],
  user: () =>
    queryOptions({
      queryKey: [...authQueries.all, "user"],
      queryFn: () => getUserSession(),
      staleTime: 0, // Allow immediate refetch after login/logout
    }),
};
